import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { notificationActions } from './notifications.actions';
import { AppNotificationDto, appNotificationInit } from './notifications.dto';

const appNotificationReducer = combineReducers({
    notification: createReducer<AppNotificationDto>(appNotificationInit)
      .handleAction(
        [
          notificationActions.success,
        ], (state, action) => action.payload),
  
  });
  
  
  export default appNotificationReducer;